import React, { useState, useEffect, useRef } from 'react';
import './Collapse03.style.css';
import { DownOutlined, UpOutlined } from '@ant-design/icons';

const Collapse03 = ({
    title,
    titleImage,
    titleStyle = {},
    children,
    contentStyle = {},
    defaultOpened = false,
    maxHeight,
    icon = (open) => (open ? <UpOutlined style={{fontSize: "14px"}}/> : <DownOutlined style={{fontSize: "14px"}}/>),
    collapsible = 'header',
    onClick = () => { },
    iconColor = '#FFFFFF',
}) => {
    const [isOpen, setIsOpen] = useState(defaultOpened);
    const [contentHeight, setContentHeight] = useState(0);
    const contentRef = useRef(null);

    const calculateTotalHeight = (element) => {
        if (!element) return 0;

        // 현재 요소의 높이를 가져옴
        let totalHeight = element.scrollHeight;

        // 자식 요소들에 대해 재귀적으로 높이를 합산
        Array.from(element.children).forEach((child) => {
            totalHeight += calculateTotalHeight(child);
        });

        return totalHeight;
    };

    useEffect(() => {
        if (contentRef.current) {
            // 전체 높이를 재귀적으로 계산
            const totalHeight = calculateTotalHeight(contentRef.current);
            setContentHeight(totalHeight);
        }
    }, [children]); // children이 변경될 때 contentHeight를 업데이트

    const handleToggleCollapse = () => {
        setIsOpen((prev) => !prev);
    };

    return (
        <div className="collapse03_layout">
            <div
                className="collapse03_header"
                onClick={() => (collapsible === 'header' ? handleToggleCollapse() : {})}
                style={{...titleStyle}}
            >

                {titleImage ? (<img
                    onClick={onClick}
                    src={titleImage}
                    style={{ width: '125px', maxWidth: 306, marginRight:'10px'}}
                />) : (<p onClick={onClick} style={{marginRight:'10px'}}>{title}</p>)}

                <span
                    style={{ color: iconColor }}
                    onClick={() => (collapsible === 'icon' ? handleToggleCollapse() : {})}
                >
                    {icon(isOpen)}
                </span>
            </div>
            <div
                ref={contentRef}
                className={`collapse03_content ${isOpen ? 'open' : ''}`}
                style={{
                    maxHeight: isOpen
                        ? maxHeight
                            ? maxHeight
                            : `${contentHeight}px`
                        : 0,
                    overflow: 'hidden',
                    transition: 'max-height 0.5s ease',
                    ...contentStyle,
                }}
            >
                {children}
            </div>
        </div>
    );
};

export default Collapse03;
